import './style.scss';
import Player from '@vimeo/player';
import {gsap} from 'gsap';
import {ScrollToPlugin} from "gsap/ScrollToPlugin";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export function video_block() {
    const block = document.querySelector('.video_block');
    if (!block) return;
    //region Pop UP  And Video
    const playButton = block?.querySelector(".play-button");
    const mediaWrapper = block?.querySelector(".cursor-video");
    const mainVideo = block?.querySelector(".content-wrapper video");

    const popup = block?.querySelector(".video-modal");
    const closeBtn = popup?.querySelector(".video-modal .close-modal");
    const modalVideo = popup?.querySelector(".video-file-url");
    const vimeoIframe = popup?.querySelector("#vimeo");
    const youtubeVideo = popup?.querySelector("#youtubeVideo");

    let vimeoPlayer;
    if (vimeoIframe) {
        vimeoPlayer = new Player(vimeoIframe);
    }

    [playButton, mediaWrapper]?.forEach(el => {
        el?.addEventListener("click", () => {
            popup?.classList.add("show");
            document.documentElement.classList.add("modal-opened");

            mainVideo?.pause();

            if (modalVideo) {
                modalVideo.play()
            }

            if (vimeoPlayer) {
                vimeoPlayer.play()
            }
            youtubeVideo?.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        });
    });

    function hideModal(e) {
        if (e.target.closest(".media-wrapper")) return;

        popup?.classList.remove("show");
        document.documentElement.classList.remove("modal-opened");


        mainVideo?.play();

        if (modalVideo) {
            modalVideo.pause();
        }
        if (vimeoPlayer) {

            vimeoPlayer?.pause()
        }
        youtubeVideo?.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }

    popup?.addEventListener("click", hideModal);
    closeBtn?.addEventListener("click", hideModal);
    window.addEventListener("keydown", e => {
        if (e.key === "Escape") hideModal(e);
    });

// endregion
    // region Numbers

    function initCounters(selector) {
        const counters = block?.querySelectorAll(selector);

        counters.forEach(counter => {
            const baseValue = parseInt(counter.dataset.baseValue);
            let currentValue = baseValue;

            function randomIncrement() {
                currentValue += 1;
                counter.textContent = currentValue;

                counter.classList.add('updated');
                setTimeout(() => counter.classList.remove('updated'), 200);

                const nextDelay = Math.random() * 30000;
                setTimeout(randomIncrement, nextDelay);
            }

            const initialDelay = Math.random() * 30000;
            setTimeout(randomIncrement, initialDelay);
        });
    }

    initCounters('.number-live-update');
    initCounters('.small-number');

    // endregion

    const textWrappers = block?.querySelectorAll('.text-wrapper');
    let currentIndex = 0;
    const delay = 8000; // 8 seconds
    if (textWrappers.length === 0) return;

    function showNextWrapper() {
        const current = textWrappers[currentIndex];
        current.classList.remove('active');

        // Calculate next index
        currentIndex = (currentIndex + 1) % textWrappers.length;
        const next = textWrappers[currentIndex];

        // Delay to allow smooth fade-out
        setTimeout(() => {
            next.classList.add('active');
        }, 50); // small delay ensures clean fade transition
    }

    // Initial display
    textWrappers[currentIndex].classList.add('active');

    // Loop every [delay] ms
    setInterval(showNextWrapper, delay);
}

